import { getAccessToken, getClientId as getRegisteredClientId, getRefreshToken, refreshTokens } from './authService';
import { API_KEY, CLIENT_APP } from './clientConfig';
import { ensureGuestSession } from './donationService';

const API_BASE = 'https://dev.oliveeb.com';

interface AppConfig {
  googleMapsApiKey?: string;
  stripPublishableKey?: string;
  stripePublishableKey?: string;
  [key: string]: any;
}

let cachedConfig: AppConfig | null = null;

export const fetchAppConfig = async (): Promise<AppConfig> => {
  if (cachedConfig) return cachedConfig;

  try {
    const authToken = getAccessToken();
    let guestToken = '';
    if (!authToken) {
      guestToken = (localStorage.getItem('guestToken') && localStorage.getItem('guestToken') !== 'undefined')
        ? localStorage.getItem('guestToken') as string
        : (await ensureGuestSession()) || '';
    }

    const clientId = (await getRegisteredClientId()) || localStorage.getItem('olitask_client_id') || '';
    const buildHeaders = (token: string): Record<string, string> => {
      const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        'O-CLIENT-APP': CLIENT_APP,
        'O-API-KEY': API_KEY,
        'O-CLIENT-ID': clientId,
      };
      if (token) headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
      return headers;
    };

    let response = await fetch(`${API_BASE}/olitask-service/api/v1/app-config`, {
      headers: buildHeaders(authToken || guestToken),
    });

    if (response.status === 401 && authToken && getRefreshToken()) {
      const refreshed = await refreshTokens();
      const freshToken = refreshed ? getAccessToken() : '';
      if (freshToken) {
        response = await fetch(`${API_BASE}/olitask-service/api/v1/app-config`, {
          headers: buildHeaders(freshToken),
        });
      }
    }

    if (response.status === 401 && !authToken) {
      localStorage.removeItem('guestToken');
      const freshGuest = await ensureGuestSession();
      if (freshGuest) {
        response = await fetch(`${API_BASE}/olitask-service/api/v1/app-config`, {
          headers: buildHeaders(freshGuest),
        });
      }
    }

    if (response.ok) {
      const data = await response.json();
      cachedConfig = data;
      return data;
    }

    console.warn('app-config fetch returned', response.status);
  } catch (error) {
    console.error('Failed to fetch app config:', error);
  }

  return {};
};

export const clearAppConfigCache = () => {
  cachedConfig = null;
};

export const getGoogleMapsApiKey = async (): Promise<string | null> => {
  const config = await fetchAppConfig();
  return config.googleMapsApiKey || null;
};
